export default{
    form: () => {
        return {
            name: "Krijo Qytet",
            submit: {
                label: "Krijo",
                action: 'submitCity'
            },
            fields: [
                [
                    {
                        value: '',
                        name: 'name',
                        label: 'Emri',
                        type: 'text-field',
                        style: 'flex-grow: 0.7',
                        required: true,
                        required_text: 'Kjo fushe eshte e detyrueshme'
                    },
                ],
            ]
        }
    }
}